var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIkonFiltrera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Filtrera",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.277,
    height: 23.608,
    viewBox: "0 0 35.277 23.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_24722",
    "data-name": "Path 24722",
    d: "M.571,9.414H24.824a3.858,3.858,0,0,0,7.651,0h2.26a.562.562,0,0,0,.551-.551.551.551,0,0,0-.551-.551H32.486a3.858,3.858,0,0,0-7.651,0H.571a.551.551,0,1,0,0,1.1ZM28.66,6.03a2.778,2.778,0,1,1-2.778,2.789h0A2.778,2.778,0,0,1,28.66,6.03Z",
    transform: "translate(-0.02 -4.957)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24723",
    "data-name": "Path 24723",
    d: "M34.745,15.435H21.517a3.869,3.869,0,0,0-7.651,0H.571a.551.551,0,1,0,0,1.1H13.8a3.858,3.858,0,0,0,7.651,0H34.745a.551.551,0,0,0,.551-.551A.562.562,0,0,0,34.745,15.435Zm-17.109,3.34a2.778,2.778,0,1,1,2.778-2.8h0a2.789,2.789,0,0,1-2.778,2.8Z",
    transform: "translate(-0.02 -4.221)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24724",
    "data-name": "Path 24724",
    d: "M34.739,22.642H10.487a3.858,3.858,0,0,0-7.651,0H.631a.551.551,0,1,0,0,1.1h2.2a3.858,3.858,0,0,0,7.651,0H34.739a.551.551,0,0,0,.551-.551.562.562,0,0,0-.551-.551ZM6.606,25.971A2.767,2.767,0,0,1,3.828,23.2h0a2.778,2.778,0,1,1,2.778,2.767Z",
    transform: "translate(-0.014 -3.49)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonFiltrera);
export default __webpack_public_path__ + "static/media/Ikon_Filtrera.4a8ab17625c8f5262b12a194e48a411c.svg";
export { ForwardRef as ReactComponent };